import uuid from "uuid";

// Mock data for Site Inspection Checklist
export const mockSiteInspectionChecklists = [
    {
        id: uuid.v4(),
        siteId: "site-123",
        location: "123 Main Street, Auckland",
        inspector: "John Smith",
        date: "2023-07-15",
        time: "09:30",
        hazardBoardSignage: true,
        environmentalPlanIssues: false,
        toolboxTalk: true,
        toolboxTalkDate: "2023-07-10",
        safetyInductions: true,
        safetyNoticeBoard: true,
        officesClean: true,
        smokoShedsClean: true,
        toiletsClean: false,
        toolEquipmentShedsAdequate: true,
        clearSafeAccess: true,
        stairwaysAccessWaysClear: true,
        hoardingsFenceSecure: true,
        looseMaterialsSecure: false,
        signageDisplayedLegible: true,
        hardhatsWorn: true,
        correctFootwear: true,
        glassesEarMuffsVestsMasks: true,
        firstAidBox: true,
        accidentRegister: true,
        fireExtinguishersAvailable: true,
        fireExtinguishersCurrent: true,
        fireExtinguishersSufficientNumber: true,
        evacuationProcedureCurrent: true,
        allEmergenciesIncluded: true,
        liftAssessmentPlan: true,
        craneCertificationCurrent: true,
        slingsChainsLifting: true,
        operatorProcedures: true,
        inspectionsDone: true,
        manCageAvailable: false,
        emergencyPlanLifting: true,
        compressedAirCondition: true,
        compressedAirGuards: true,
        compressedAirTrainedUser: true,
        excavationsShored: true,
        hotWorkPermits: true,
        weldingFireExtinguishers: true,
        weldingOperatorsPPE: true,
        mainBoardLockable: true,
        currentTaggedLeads: true,
        currentTaggedPlant: true,
        currentTaggedLifeguards: true,
        leadsSafelyPlaced: true,
        equipmentGoodCondition: true,
        appropriateGuardsEquipment: true,
        adequateTemporaryLighting: true,
        chemicalsCorrectlyStored: true,
        sdsAvailable: true,
        chemicalOperatorsPPE: true,
        patToolWof: true,
        staffTrainedTools: true,
        patSignage: true,
        scaffoldingNotifiableWeekly: true,
        scaffoldingHandrails: true,
        scaffoldingToeBoards: true,
        scaffoldingPlatforms: true,
        scaffoldingLadders: true,
        scaffoldingBaseSound: true,
        scaffoldingWorkPlatformsClear: true,
        scaffoldingPlatformsTripFree: true,
        scaffoldingPlanksTied: true,
        scaffoldingHeadroomClear: true,
        scaffoldingTiesBracing: true,
        laddersGoodCondition: true,
        laddersSecured: true,
        laddersStays: true,
        laddersWorkingStepsDown: true,
        fallHazardsFloorEdges: true,
        fallHazardsLiftShafts: true,
        remedialActions: [
            {
                action: "Clean toilets regularly",
                comments: "Need to establish a cleaning schedule",
                person: "Site Manager",
                completed: false
            },
            {
                action: "Secure loose materials",
                comments: "Materials on 3rd floor need to be secured",
                person: "Team Lead",
                completed: false
            }
        ]
    },
    {
        id: uuid.v4(),
        siteId: "site-456",
        location: "456 Park Avenue, Wellington",
        inspector: "Jane Doe",
        date: "2023-08-20",
        time: "14:15",
        hazardBoardSignage: true,
        environmentalPlanIssues: true,
        toolboxTalk: true,
        toolboxTalkDate: "2023-08-15",
        safetyInductions: true,
        safetyNoticeBoard: true,
        officesClean: true,
        smokoShedsClean: true,
        toiletsClean: true,
        toolEquipmentShedsAdequate: true,
        clearSafeAccess: true,
        stairwaysAccessWaysClear: true,
        hoardingsFenceSecure: false,
        looseMaterialsSecure: true,
        signageDisplayedLegible: true,
        hardhatsWorn: false,
        correctFootwear: true,
        glassesEarMuffsVestsMasks: false,
        firstAidBox: true,
        accidentRegister: true,
        fireExtinguishersAvailable: true,
        fireExtinguishersCurrent: false,
        fireExtinguishersSufficientNumber: true,
        evacuationProcedureCurrent: true,
        allEmergenciesIncluded: false,
        liftAssessmentPlan: false,
        craneCertificationCurrent: false,
        slingsChainsLifting: false,
        operatorProcedures: false,
        inspectionsDone: false,
        manCageAvailable: false,
        emergencyPlanLifting: false,
        compressedAirCondition: true,
        compressedAirGuards: true,
        compressedAirTrainedUser: true,
        excavationsShored: false,
        hotWorkPermits: true,
        weldingFireExtinguishers: true,
        weldingOperatorsPPE: false,
        mainBoardLockable: true,
        currentTaggedLeads: true,
        currentTaggedPlant: true,
        currentTaggedLifeguards: false,
        leadsSafelyPlaced: true,
        equipmentGoodCondition: true,
        appropriateGuardsEquipment: true,
        adequateTemporaryLighting: true,
        chemicalsCorrectlyStored: false,
        sdsAvailable: false,
        chemicalOperatorsPPE: false,
        patToolWof: true,
        staffTrainedTools: true,
        patSignage: true,
        scaffoldingNotifiableWeekly: true,
        scaffoldingHandrails: true,
        scaffoldingToeBoards: true,
        scaffoldingPlatforms: true,
        scaffoldingLadders: true,
        scaffoldingBaseSound: true,
        scaffoldingWorkPlatformsClear: false,
        scaffoldingPlatformsTripFree: false,
        scaffoldingPlanksTied: true,
        scaffoldingHeadroomClear: true,
        scaffoldingTiesBracing: true,
        laddersGoodCondition: false,
        laddersSecured: false,
        laddersStays: true,
        laddersWorkingStepsDown: true,
        fallHazardsFloorEdges: true,
        fallHazardsLiftShafts: false,
        remedialActions: [
            {
                action: "Fix fence around site perimeter",
                comments: "North side fence is loose and needs securing",
                person: "Contractor",
                completed: false
            },
            {
                action: "Ensure hardhat usage",
                comments: "Several workers observed without hardhats",
                person: "Safety Officer",
                completed: false
            },
            {
                action: "Update fire extinguisher certification",
                comments: "Two extinguishers are past their inspection date",
                person: "Site Manager",
                completed: true
            }
        ]
    }
];

// Get mock data function
export const getMockSiteInspectionChecklists = () => {
    return mockSiteInspectionChecklists;
};

// Get single checklist by ID
export const getMockSiteInspectionChecklistById = (id) => {
    return mockSiteInspectionChecklists.find(checklist => checklist.id === id);
}; 